// extracted by mini-css-extract-plugin
export var alignDiscLeft = "p_qw d_fp d_bG d_dv";
export var alignLeft = "p_qh d_fp d_bG d_dv";
export var alignDiscCenter = "p_qx d_fq d_bD d_dw";
export var alignCenter = "p_bP d_fq d_bD d_dw";
export var alignDiscRight = "p_qy d_fr d_bH d_dx";
export var alignRight = "p_qj d_fr d_bH d_dx";
export var footerContainer = "p_qz d_dW d_bW";
export var footerContainerFull = "p_qB d_dT d_bW";
export var footerHeader = "p_kf d_kf";
export var footerTextWrapper = "p_qC d_w";
export var footerDisclaimerWrapper = "p_km d_km d_ck";
export var badgeWrapper = "p_qD d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "p_qF d_bz d_bJ d_bN d_bL";
export var wide = "p_qG d_cy";
export var right = "p_qH d_bK";
export var line = "p_fk d_fl d_cv";
export var badgeDisclaimer = "p_qJ d_bC d_bP d_bJ";
export var badgeContainer = "p_qK d_bz d_bH d_bP";
export var badge = "p_qL";
export var padding = "p_qM d_c7";
export var end = "p_qN d_bH";
export var linkWrapper = "p_qP d_dB";
export var link = "p_mC d_dB";
export var colWrapper = "p_qQ d_cx";
export var consent = "p_f d_f d_bC d_bP";
export var disclaimer = "p_qR d_bz d_bJ";
export var media = "p_qS d_bx d_dy";
export var itemRight = "p_qT";
export var itemLeft = "p_qV";
export var itemCenter = "p_qW";
export var exceptionWeight = "p_qX s_rB";